import { css } from 'emotion'
// import { LINK_COLOR, LINK_COLOR_DARK  } from 'constants/styleConstants'

export const NoteMessageStyles = css`
  font-size: 0.75em;
  font-style: italic;
`
